<div class="container-fluid">
  <div class="row">

    <!-- Sidebar -->
    <div class="col-12 col-md-3 col-lg-2" style="height: 100%;">
      <div class="detailsmenu">

        <!-- Personal Details -->
        <div class="row personal ">
          <div class="col-12 d-flex align-items-center gap-2" routerLinkActive="active-item"
            [routerLinkActiveOptions]="{ exact: true }">
            <span>
              <img class="imgicon" src="assets/settingIcon/user.png" alt="User Icon" style="width: 30px; height: 30px;">
            </span>
            <a routerLink="personaldetails" class="text-decoration-none text-dark">
              <p class="mb-0">Personal details</p>
            </a>
          </div>
        </div>

        <!-- Notification -->
        <div class="row personal border-top g-0" routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: true }">
          <div class="col-12 d-flex align-items-center gap-2">
            <span>
              <img src="assets/settingIcon/notification.png" alt="Notification Icon" style="width: 30px; height: 30px;">
            </span>
            <a routerLink="notification" class="text-decoration-none text-dark">
              <p class="mb-0">App Settings</p>
            </a>
          </div>
        </div>

        <!-- Preferences -->
        <div class="row personal border-top g-0" routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: true }">
          <div class="col-12 d-flex align-items-center gap-2">
            <span>
              <img src="assets/settingIcon/preference.png" alt="Preference Icon" style="width: 30px; height: 30px;">
            </span>
            <a routerLink="preference" class="text-decoration-none text-dark">
              <p class="mb-0">Terms & Conditions</p>
            </a>
          </div>
        </div>

        <!-- Security -->
        <div class="row personal border-top g-0" routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: true }">
          <div class="col-12 d-flex align-items-center gap-2">
            <span>
              <img src="assets/settingIcon/security.png" alt="Security Icon" style="width: 30px; height: 30px;">
            </span>
            <a routerLink="security" class="text-decoration-none text-dark">
              <p class="mb-0">Security</p>
            </a>
          </div>
        </div>

        <!-- Cancellation Reasons -->
        <div class="row personal border-top g-0" routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: true }">
          <div class="col-12 d-flex align-items-center gap-2">
            <span>
              <img src="assets/settingIcon/preference.png" alt="Cancellation Reasons Icon" style="width: 30px; height: 30px;">
            </span>
            <a routerLink="cancellation-reasons" class="text-decoration-none text-dark">
              <p class="mb-0">Cancellation Reasons</p>
            </a>
          </div>
        </div>

      </div>
    </div>

    <!-- Main Content -->
    <div class="col-12 col-md-9 col-lg-10">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>